import { render, staticRenderFns } from "./ModelDetail.vue?vue&type=template&id=4a7f5dd6&"
import script from "./ModelDetail.vue?vue&type=script&lang=js&"
export * from "./ModelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports